export default __webpack_public_path__ + "static/media/Group 13317.a30cfa0e.png";